import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/pending_order_vs_available_qty';


const PendingOrderVsAvailableQty = ({ t }) => (
  <Container>
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

PendingOrderVsAvailableQty.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(PendingOrderVsAvailableQty);
